import React from 'react';
import styles from './index.css';
import { LoginIdContext } from '../../../../utils/loginId';
import BottomBar from '../../bottomBar';
class FloorItem extends React.PureComponent {
    render() {
        const { content, bottomBarData, index, replyId, setReplyId, allow_comment, curPage } = this.props;
        return (React.createElement("div", { className: styles.floor_item },
            React.createElement("span", { className: styles.floor_num }, index + 1),
            React.createElement("p", { className: styles.username },
                React.createElement("a", { href: `//gentie.ifeng.com/myComments?guid=${content.user_id}`, target: "_blank" }, content.uname),
                React.createElement("span", null,
                    " [",
                    content.ip_from,
                    "\u7F51\u53CB]")),
            React.createElement("p", { className: styles.contentTxt, dangerouslySetInnerHTML: { __html: content.comment_contents || '' } }),
            React.createElement("div", { className: styles.bottom_bar },
                React.createElement(LoginIdContext.Consumer, null, (value) => (React.createElement(BottomBar, { loginId: value.loginId, config: value.config, content: bottomBarData, replyId: replyId, setReplyId: setReplyId, jubCommentIdArr: value.jubCommentIdArr, curPage: curPage }))))));
    }
}
export default FloorItem;
